import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useBranding } from '@/lib/branding';

// PaceSlot brand kit: the "PS" mark plus a two-tone wordmark (PACE in
// white, SLOT in lime) — the split is deliberate so it reads PACE SLOT, not
// PACES LOT. The kit also asks for clear space of ~0.8x the letter height
// between mark and wordmark, hence the wider gap. A custom logo_url /
// app_name from Settings still takes over.
const MARK_SRC = '/paceslot-mark.svg';

export const Wordmark = ({ name, className }) => {
  const isPaceSlot = (name || '').toLowerCase() === 'paceslot';
  return (
    <span className={cn('font-heading font-black uppercase tracking-tight leading-none', className)}>
      {isPaceSlot ? (
        <>
          <span className="text-white">Pace</span>
          <span className="text-[#B0EA00]">Slot</span>
        </>
      ) : (
        <>
          {name}<span className="text-volt">.</span>
        </>
      )}
    </span>
  );
};

export const Logo = ({ className, showWordmark = true, size = 'default' }) => {
  const { app_name, logo_url } = useBranding();
  const sizes = {
    sm: 'h-8',
    default: 'h-10',
    lg: 'h-14',
  };
  return (
    <Link to="/" className={cn('flex items-center gap-4 group', className)} data-testid="brand-logo">
      <img
        src={logo_url || MARK_SRC}
        alt={app_name}
        className={cn('w-auto object-contain transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105', sizes[size])}
      />
      {showWordmark && (
        <Wordmark name={app_name} className="text-xl hidden sm:inline" />
      )}
    </Link>
  );
};
